export default {
  DISPLAY_AS: {
    URL: 'url',
    TEXT_INPUT: 'text-input',
    BOOLEAN: 'boolean',
    SWITCH: 'switch',
    TIME_ZONE_SELECT: 'time-zone-select',
    SUB_HEADING: 'sub-heading',
    ADD_GRID_RESOURCE: 'add-grid-resource',
    RESOURCE: 'resource',
    GRID: 'grid',
    TAG_INPUT: 'tag-input',
    SELECT: 'select',
    KEY_VALUE_PAIRS: 'key-value-pairs',
    POINTS_OF_INTEREST: 'points-of-interest',
    SEARCH_BY: 'search-by',
    FILE_UPLOADER: 'file-uploader',
    COUNTRY_SELECT: 'country-select',
    TEXT_AREA: 'text-area',
    MULTI_SELECT: 'multi-select',
    MULTI_SELECT_GROUP: 'multi-select-group',
    GROUP: 'group',
    TABS: 'tabs',
    DEBTORS_MULTI_SELECT: 'debtor-multi-select',
    FEATURE_SELECT: 'feature-select',
    O_DATA_INDEX_MULTI_SELECT: 'o-data-index-multi-select',
    LAT_LONG_MAP_SEARCH: 'lat-long-map-search',
    HOTEL: 'hotel',
    HOTEL_REVIEW: 'hotel_review',
    LAT_LNG_MAP: 'lat-lng-map',
    RANGE: 'range',
    O_DATA_SELECT: 'o-data-select',
    HOTEL_TAG_SELECT: 'hotel-tag-select',
    FILE_DOWNLOADER: 'file-downloader',
    POLICY_CODE_SELECT: 'policy-code-select',
    REASON_FOR_TRAVEL_SELECT: 'reason-for-travel-select',
    COMPANY_REFERENCE_SELECT: 'company-reference-code-select',
    TAG_SELECT: 'tag-select',
    SPACER: 'spacer',
    CONFIRM_BUTTON: 'confirm-button',
    REMARKS_EDITOR: 'remarks-editor',
  },
  MICRO_SERVICE: {
    DEBTORS: 'debtors'
  },
  DATA_SOURCES: {
    ODATA: 'odata',
    AUTH_ZERO: 'auth0'
  },
  PRODUCT_FAMILY: {
    CTM: 'CTM',
    AIR: 'Air',
    VEHICLE: 'Vehicle',
    HOTEL: 'Hotel',
    RAIL: 'Rail',
    PRODUCTS: 'Products',
    // CTM: 'CTM'
  },
  PRODUCT:{
    LIGHTNINGBOOK: 'LightningBook',
    CTMMOBILE: 'CTMMobile',
    CTMPORTAL: 'CTMPortal',
    CTMAPPROVE: 'CTMApprove',
    HOTELREVIEW: 'HotelReview',
    RIDESHARE: 'RideShare',
    RISK: 'Risk',
    TRIPS: 'Trips'
  }
}


// WEBPACK FOOTER //
// ./src/config/constants.js